const footer = document.querySelector('footer');

if(footer) {
  const toTopBtn = footer.querySelector('.to-top-btn');
  if(toTopBtn) {
    toTopBtn.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    })
  }
}